import { Button, Icon } from 'rbx';
import * as React from 'react';
import { Mutation } from '@apollo/client/react/components';

import { IMPORT_FROM_PARTS_CSV_MUTATION } from '../../../../api/GraphQLQueries/Onboarding';
import { MaintenanceButton } from '../../../../components/ui/MaintenanceButton';
import { notification } from '../../../../utils/notification';

interface IProps {
    plantId: string;
    disabled?: boolean;
}

interface IState {
    disabled: boolean;
}

export default class IndexCsvMutation extends React.Component<IProps, IState> {
    public state: IState = {
        disabled: false,
    };

    private onError = (): void => {
        notification.error('Parse csv error');
        this.setState({ disabled: false });
    };

    private onCompleted = (): void => {
        notification.success('Successfully started csv parsing');
        this.setState({ disabled: true });
    };

    public render = () => {
        const { disabled } = this.state;
        const { plantId } = this.props;

        return (
            <>
                <Mutation
                    mutation={IMPORT_FROM_PARTS_CSV_MUTATION}
                    variables={{ plantId }}
                    onCompleted={this.onCompleted}
                    onError={this.onError}
                    awaitRefetchQueries={false}
                >
                    {(doImportPartsMutation, { loading }) => (
                        <>
                            {loading ? (
                                <>
                                    <Button color="info">
                                        <Icon>
                                            <i className="fa fa-cog fa-spin" />
                                        </Icon>
                                        <span>Processing part import</span>
                                    </Button>
                                    <div>
                                        <small>Please wait, this could take a few minutes.</small>
                                    </div>
                                </>
                            ) : (
                                <MaintenanceButton
                                    type="button"
                                    disabled={disabled}
                                    onClick={() => {
                                        if (!disabled) {
                                            doImportPartsMutation();
                                        }
                                    }}
                                >
                                    Index plantserv-parts.csv
                                </MaintenanceButton>
                            )}
                        </>
                    )}
                </Mutation>
            </>
        );
    };
}
